"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalHistoryModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const medical_doc_entity_1 = require("./medical-doc.entity");
const medical_upload_link_entity_1 = require("./medical-upload-link.entity");
const medical_history_service_1 = require("./medical-history.service");
const medical_history_controller_1 = require("./medical-history.controller");
const medical_upload_controller_1 = require("./medical-upload.controller");
const notifications_module_1 = require("../notifications/notifications.module");
let MedicalHistoryModule = class MedicalHistoryModule {
};
exports.MedicalHistoryModule = MedicalHistoryModule;
exports.MedicalHistoryModule = MedicalHistoryModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([medical_doc_entity_1.MedicalDoc, medical_upload_link_entity_1.MedicalUploadLink]), notifications_module_1.NotificationsModule],
        providers: [medical_history_service_1.MedicalHistoryService],
        controllers: [medical_history_controller_1.MedicalHistoryController, medical_upload_controller_1.MedicalUploadController],
        exports: [medical_history_service_1.MedicalHistoryService],
    })
], MedicalHistoryModule);
